import { render, staticRenderFns } from "./output_config.vue?vue&type=template&id=70049798&scoped=true"
import script from "./output_config.vue?vue&type=script&lang=js"
export * from "./output_config.vue?vue&type=script&lang=js"
import style0 from "./output_config.vue?vue&type=style&index=0&id=70049798&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70049798",
  null
  
)

export default component.exports